import React, { useEffect, useState } from 'react';
import { socket } from '../socket';

// Bandeau global : previent quand le navigateur est hors-ligne ou que la
// connexion temps reel au serveur est perdue (socket.io tente de se reconnecter).
export function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);
  const [socketDown, setSocketDown] = useState(false);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    const up = () => setSocketDown(false);
    const down = () => setSocketDown(true);
    socket.on('connect', up);
    socket.on('disconnect', down);
    socket.on('connect_error', down);
    if (socket.connected) setSocketDown(false);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
      socket.off('connect', up);
      socket.off('disconnect', down);
      socket.off('connect_error', down);
    };
  }, []);
  if (online && !socketDown) return null;
  const msg = !online ? 'Hors ligne : verifie ta connexion internet.' : 'Connexion au serveur perdue, reconnexion...';
  return (
    <div role="status" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 3000, textAlign: 'center', padding: '0.4rem', fontSize: '0.85rem', fontWeight: 700, color: '#fff', background: !online ? '#dc2626' : '#d97706', boxShadow: '0 2px 8px rgba(0,0,0,0.25)' }}>
      {msg}
    </div>
  );
}
